import { useState } from "react";
import "./Switch.css";

export default function Switch({value,onChange,type='switch'}) {
  if (type==='switch')
  {
    return (
      <label className="switch">
        <input
          type="checkbox"
          checked={value}
          onChange={(e) => onChange (e.target.checked)}
        />
        <span className="slider"></span>
      </label>
    );
  }else {
    return (
        <input className="checkbox"
          type="checkbox"
          checked={value}
          onChange={(e) => onChange (e.target.checked)}
        />
    );
  }
}
